import JobListingJobCard from '@/modules/JobListingJobCardList/components/JobListingJobCard/JobListingJobCard';
import JobListingRegisterCtaBanner from '@/modules/JobListingRegisterCtaBanner';
import { IJobDetail, JobSearchWebCriteria } from '@/types/jobs';
import { getSeededIntInclusive } from '@/utils/getRandomInt';
import React from 'react';

export type JobCardListProps =
  | {
      jobs: IJobDetail[];
      suppressCTABanner: true;
      isHighlighted?: boolean;
      ctaPosition?: 'bottom';
      // See JobListingJobCardProps.includeJsonLd - only set this from an indexable listing page.
      includeJsonLd?: boolean;
      // See JobListingJobCardProps.origin.
      origin?: string;
    }
  | {
      jobs: IJobDetail[];
      suppressCTABanner?: false;
      isUserLoggedIn: boolean;
      query: JobSearchWebCriteria; // the criteria for the search that resulted in this banner being shown
      isHighlighted?: boolean;
      ctaPosition?: 'bottom' | 'random';
      // See JobListingJobCardProps.includeJsonLd - only set this from an indexable listing page.
      includeJsonLd?: boolean;
      // See JobListingJobCardProps.origin.
      origin?: string;
    };

const JobListingJobCardList = (props: JobCardListProps) => {
  const { jobs, suppressCTABanner, origin } = props;
  // Get a job card index from 1 to 5 (allowing the banner to land between
  // positions 3 and 7), seeded from the job list itself so the value is
  // identical on the server render and the client hydration render.
  const randomIndex = getSeededIntInclusive(jobs.map(job => job.id).join('-'), 1, 5);
  // make sure the banner is always shown when the job list is shorter than random index
  const bannerIndex =
    jobs.length - 1 < randomIndex || props?.ctaPosition === 'bottom'
      ? jobs.length - 1
      : randomIndex;

  return (
    <>
      {jobs.map((job, index) => {
        return (
          <div key={job.id}>
            <JobListingJobCard
              job={job}
              isHighlighted={props.isHighlighted ?? false}
              position={index + 1}
              includeJsonLd={props.includeJsonLd}
              origin={origin}
            />
            {index === bannerIndex &&
              (suppressCTABanner ? (
                <JobListingRegisterCtaBanner suppressCTABanner={true} />
              ) : (
                <JobListingRegisterCtaBanner
                  isUserLoggedIn={props.isUserLoggedIn}
                  position={bannerIndex + 2}
                  query={props.query}
                />
              ))}
          </div>
        );
      })}
    </>
  );
};

export default JobListingJobCardList;
